Object.defineProperty(exports, "__esModule", {
    value: true
});
var _async_to_generator = require("@swc/helpers/_/_async_to_generator");
var _object_spread = require("@swc/helpers/_/_object_spread");
var require_utils = require('./utils.cjs');
//#region src/dom.ts
function safeWrapper(callback, disableWarn) {
    return _async_to_generator._(function*() {
        try {
            return yield callback();
        } catch (e) {
            !disableWarn && require_utils.warn(e);
            return;
        }
    })();
}
function isStaticResourcesEqual(url1, url2) {
    var REG_EXP = /^(https?:)?\/\//i;
    return url1.replace(REG_EXP, "").replace(/\/$/, "") === url2.replace(REG_EXP, "").replace(/\/$/, "");
}
function createScript(info) {
    var script = null;
    var needAttach = true;
    var timeout = 2e4;
    var timeoutId;
    var scripts = document.getElementsByTagName("script");
    for(var i = 0; i < scripts.length; i++){
        var s = scripts[i];
        var scriptSrc = s.getAttribute("src");
        if (scriptSrc && isStaticResourcesEqual(scriptSrc, info.url)) {
            script = s;
            needAttach = false;
            break;
        }
    }
    if (!script) {
        var attrs = info.attrs;
        script = document.createElement("script");
        script.type = (attrs === null || attrs === void 0 ? void 0 : attrs["type"]) === "module" ? "module" : "text/javascript";
        var createScriptRes = void 0;
        if (info.createScriptHook) {
            createScriptRes = info.createScriptHook(info.url, info.attrs);
            if (createScriptRes instanceof HTMLScriptElement) script = createScriptRes;
            else if (typeof createScriptRes === "object") {
                if ("script" in createScriptRes && createScriptRes.script) script = createScriptRes.script;
                if ("timeout" in createScriptRes && createScriptRes.timeout) timeout = createScriptRes.timeout;
            }
        }
        if (!script.src) script.src = info.url;
        if (attrs && !createScriptRes) Object.keys(attrs).forEach((name)=>{
            if (script) {
                if (name === "async" || name === "defer") script[name] = attrs[name];
                else if (!script.getAttribute(name)) script.setAttribute(name, attrs[name]);
            }
        });
    }
    var executionError = null;
    var executionErrorHandler = typeof window !== "undefined" ? (evt)=>{
        if (evt.filename && isStaticResourcesEqual(evt.filename, info.url)) {
            var err = /* @__PURE__ */ new Error(`ScriptExecutionError: Script "${info.url}" loaded but threw a runtime error during execution: ${evt.message} (${evt.filename}:${evt.lineno}:${evt.colno})`);
            err.name = "ScriptExecutionError";
            executionError = err;
        }
    } : null;
    if (executionErrorHandler) window.addEventListener("error", executionErrorHandler);
    var onScriptComplete = (prev, event)=>_async_to_generator._(function*() {
            clearTimeout(timeoutId);
            if (executionErrorHandler) window.removeEventListener("error", executionErrorHandler);
            var onScriptCompleteCallback = ()=>{
                if ((event === null || event === void 0 ? void 0 : event.type) === "error") {
                    var networkError = /* @__PURE__ */ new Error((event === null || event === void 0 ? void 0 : event.isTimeout) ? `ScriptNetworkError: Script "${info.url}" timed out.` : `ScriptNetworkError: Failed to load script "${info.url}" - the script URL is unreachable or the server returned an error (network failure, 404, CORS, etc.)`);
                    networkError.name = "ScriptNetworkError";
                    (info === null || info === void 0 ? void 0 : info.onErrorCallback) && (info === null || info === void 0 ? void 0 : info.onErrorCallback(networkError));
                } else if (executionError) (info === null || info === void 0 ? void 0 : info.onErrorCallback) && (info === null || info === void 0 ? void 0 : info.onErrorCallback(executionError));
                else (info === null || info === void 0 ? void 0 : info.cb) && (info === null || info === void 0 ? void 0 : info.cb());
            };
            if (script) {
                script.onerror = null;
                script.onload = null;
                safeWrapper(()=>{
                    var _info_needDeleteScript = info.needDeleteScript, needDeleteScript = _info_needDeleteScript === void 0 ? true : _info_needDeleteScript;
                    if (needDeleteScript) (script === null || script === void 0 ? void 0 : script.parentNode) && script.parentNode.removeChild(script);
                });
                if (prev && typeof prev === "function") {
                    var result = prev(event);
                    if (result instanceof Promise) {
                        var res = yield result;
                        onScriptCompleteCallback();
                        return res;
                    }
                    onScriptCompleteCallback();
                    return result;
                }
            }
            onScriptCompleteCallback();
        })();
    script.onerror = onScriptComplete.bind(null, script.onerror);
    script.onload = onScriptComplete.bind(null, script.onload);
    timeoutId = setTimeout(()=>{
        onScriptComplete(null, {
            type: "error",
            isTimeout: true
        });
    }, timeout);
    return {
        script,
        needAttach
    };
}
function createLink(info) {
    var link = null;
    var needAttach = true;
    var links = document.getElementsByTagName("link");
    for(var i = 0; i < links.length; i++){
        var l = links[i];
        var linkHref = l.getAttribute("href");
        var linkRel = l.getAttribute("rel");
        if (linkHref && isStaticResourcesEqual(linkHref, info.url) && linkRel === info.attrs["rel"]) {
            link = l;
            needAttach = false;
            break;
        }
    }
    if (!link) {
        link = document.createElement("link");
        link.setAttribute("href", info.url);
        var createLinkRes = void 0;
        var attrs = info.attrs;
        if (info.createLinkHook) {
            createLinkRes = info.createLinkHook(info.url, attrs);
            if (createLinkRes instanceof HTMLLinkElement) link = createLinkRes;
        }
        if (attrs && !createLinkRes) Object.keys(attrs).forEach((name)=>{
            if (link && !link.getAttribute(name)) link.setAttribute(name, attrs[name]);
        });
    }
    var onLinkComplete = (prev, event)=>{
        var onLinkCompleteCallback = ()=>{
            if ((event === null || event === void 0 ? void 0 : event.type) === "error") (info === null || info === void 0 ? void 0 : info.onErrorCallback) && (info === null || info === void 0 ? void 0 : info.onErrorCallback(event));
            else (info === null || info === void 0 ? void 0 : info.cb) && (info === null || info === void 0 ? void 0 : info.cb());
        };
        if (link) {
            link.onerror = null;
            link.onload = null;
            safeWrapper(()=>{
                var _info_needDeleteLink = info.needDeleteLink, needDeleteLink = _info_needDeleteLink === void 0 ? true : _info_needDeleteLink;
                if (needDeleteLink) (link === null || link === void 0 ? void 0 : link.parentNode) && link.parentNode.removeChild(link);
            });
            if (prev) {
                var res = prev(event);
                onLinkCompleteCallback();
                return res;
            }
        }
        onLinkCompleteCallback();
    };
    link.onerror = onLinkComplete.bind(null, link.onerror);
    link.onload = onLinkComplete.bind(null, link.onload);
    return {
        link,
        needAttach
    };
}
function loadScript(url, info) {
    var _info_attrs = info.attrs, attrs = _info_attrs === void 0 ? {} : _info_attrs, createScriptHook = info.createScriptHook;
    return new Promise((resolve, reject)=>{
        var _createScript = createScript({
            url,
            cb: resolve,
            onErrorCallback: reject,
            attrs: _object_spread._({
                fetchpriority: "high"
            }, attrs),
            createScriptHook,
            needDeleteScript: true
        }), script = _createScript.script, needAttach = _createScript.needAttach;
        needAttach && document.head.appendChild(script);
    });
}
//#endregion
exports.createLink = createLink;
exports.createScript = createScript;
exports.isStaticResourcesEqual = isStaticResourcesEqual;
exports.loadScript = loadScript;
exports.safeWrapper = safeWrapper; //# sourceMappingURL=dom.cjs.map
